/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Load_ErrorInputs */

const en_course_load_error = /** @type {(inputs: Course_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load course`)
};

const ja_course_load_error = /** @type {(inputs: Course_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースの読み込みに失敗しました`)
};

const fr_course_load_error = /** @type {(inputs: Course_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du chargement du cours`)
};

const de_course_load_error = /** @type {(inputs: Course_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden des Kurses`)
};

/**
* | output |
* | --- |
* | "Failed to load course" |
*
* @param {Course_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_load_error = /** @type {((inputs?: Course_Load_ErrorInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Load_ErrorInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_load_error(inputs)
	if (locale === "ja") return ja_course_load_error(inputs)
	if (locale === "fr") return fr_course_load_error(inputs)
	return de_course_load_error(inputs)
});